<template>
  <section class="bg-white">
    <div class="px-4 mx-auto max-w-5xl lg:px-0" :class="showDivider ? 'pt-4 pb-8 md:pt-6 md:pb-8' : 'pt-8'">
      <svg
        v-if="showDivider"
        class="block mx-auto w-full max-w-3xl h-auto"
        width="740"
        height="42"
        viewBox="0 0 740 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect y="20.5" width="338" height="1" fill="#E0D5C5" />
        <mask :id="dividerMaskId" fill="white">
          <path
            d="M354 21C354 12.1634 361.163 5 370 5C378.837 5 386 12.1634 386 21C386 29.8366 378.837 37 370 37C361.163 37 354 29.8366 354 21Z"
          />
        </mask>
        <path
          d="M354 21M386 21M386 21M354 21M370 5M386 21M370 37M354 21M370 37V36C361.716 36 355 29.2843 355 21H354H353C353 30.3888 360.611 38 370 38V37ZM386 21H385C385 29.2843 378.284 36 370 36V37V38C379.389 38 387 30.3888 387 21H386ZM370 5V6C378.284 6 385 12.7157 385 21H386H387C387 11.6112 379.389 4 370 4V5ZM370 5V4C360.611 4 353 11.6112 353 21H354H355C355 12.7157 361.716 6 370 6V5Z"
          fill="#E0D5C5"
          :mask="`url(#${dividerMaskId})`"
        />
        <path
          d="M369.997 26.8327C373.219 26.8327 375.831 24.221 375.831 20.9993C375.831 17.7777 373.219 15.166 369.997 15.166C366.776 15.166 364.164 17.7777 364.164 20.9993C364.164 24.221 366.776 26.8327 369.997 26.8327Z"
          fill="#F1574B"
        />
        <rect x="402" y="20.5" width="338" height="1" fill="#E0D5C5" />
      </svg>

      <div :class="showDivider ? 'mt-8 md:mt-16' : ''">
        <nuxt-img
          v-if="imageSrc"
          :src="imageSrc"
          :alt="imageAlt"
          :width="imageWidth"
          :height="imageHeight"
          format="webp"
          loading="lazy"
          sizes="xs:100vw sm:672px"
          class="block w-full h-auto rounded-[15px]"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
const dividerMaskId = `image-top-line-divider-${useId()}`

defineProps({
  showDivider: {
    type: Boolean,
    default: false
  },
  imageSrc: {
    type: String,
    default: '/assets/images/img-mens.jpg'
  },
  imageAlt: {
    type: String,
    default: ''
  },
  imageWidth: {
    type: Number,
    default: 960
  },
  imageHeight: {
    type: Number,
    default: 450
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Image Top Line',
  inputs: [
    {
      name: 'showDivider',
      type: 'boolean',
      friendlyName: 'Show divider above image',
      defaultValue: false
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/img-mens.jpg'
    },
    {
      name: 'imageAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'imageWidth',
      type: 'number',
      defaultValue: 960
    },
    {
      name: 'imageHeight',
      type: 'number',
      defaultValue: 450
    }
  ]
})
</script>
